import {Container, Flex, Heading, Text, Textarea, VStack} from '@chakra-ui/react';
import {useTranslation} from 'hooks';
import React, {FC, useEffect, useState} from 'react';

interface Props {
  value: string;
  onChange: (value: string) => void;
  title: string;
  placeholder?: string;
  showTextError?: boolean;
}

export const SpecialMentions: FC<Props> = ({placeholder, title, value, onChange, showTextError}) => {
  const {t} = useTranslation();
  const [text, setText] = useState(value);

  const handleTextAreaChange = (value: string) => {
    setText(value);
  };

  const handleSpecialMentionsChange = () => {
    if (text) {
      onChange(text);
    } else {
      onChange('');
    }
  };

  useEffect(() => {
    if (value !== text) {
      setText(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const outlineStyle = showTextError && !text ? '2px solid red;' : '2px solid 3182ce;';
  return (
    <Container variant="white-block">
      <VStack alignItems="flex-start" h="100%" spacing="0">
        <Heading as="h5" fontSize="16px" fontWeight="600" mb="12px">
          {title}
        </Heading>
        <Textarea
          value={text}
          onChange={(e) => handleTextAreaChange(e.target.value)}
          onBlur={handleSpecialMentionsChange}
          placeholder={placeholder ?? title}
          maxLength={300}
          fontSize="17px"
          outline={outlineStyle}
        />
      </VStack>

      {showTextError && !text && (
        <Flex mt="5px">
          <Text color="red.500" fontWeight="normal" fontSize="sm">
            {t('errorCourierExpressComment')}
          </Text>
        </Flex>
      )}
    </Container>
  );
};
